const navs = {
  employeeMaster: '/employee-master',
  userMaster: '/user-master',
  editEmployeeMaster: (id) => `/employee-master/edit/${id}`,
  editUserMaster: (id) => `/user-master/edit/${id}`,
  editIfdCompetitorMaster: (id) => `/ifd-competitor-master/edit/${id}`,
  editCompetitorOffers: (id) => `/competitor-offers/edit/${id}`,
  editDivisionMaster: (id) => `/division-master/edit/${id}`,
  editEmployeeMapping: (id) => `/employee-mapping/edit/${id}`,
  editOutletMaster: (id) => `/outlet-master/edit/${id}`,
  editPlantMaster: (id) => `/plant-master/edit/${id}`,
  editVenueMaster: (id) => `/venue-master/edit/${id}`,
  editProspectMaster: (id) => `/prospect-master/edit/${id}`,
  getEditMenuAccess: (id) => `/menu-access/edit/${id}`,
  editShiftMaster: (id) => `/shift-master/edit/${id}`,
  editPjpMaster: (id) => `/pjp-creation/edit/${id}`,
  viewBOPlanApproval: (id) => `/plan-validation/edit/${id}`,
  viewBOPlan: `/plan-report`,
  viewBOPlanDetails: (id) => `/plan-report/view/${id}`,
  viewClaimExpense: (id) => `/claim-details-report/view/${id}`,
  viewBOPlanDevApproval: (id) => `/plan-deviation-approval-backoffice/edit/${id}`,
  viewManagerPlanDevApproval: (id) => `/plan-deviation-approval-manager/edit/${id}`,
  viewProspectApproval: (id) => `/prospect-validation/edit/${id}`,
  ClaimApprovalBOIF: `/approval-claim-backoffice`,
  viewClaimBOApproval: (id) => `/approval-claim-backoffice/edit/${id}`,
  ClaimApprovalExecutive: `/approval-claim-executive`,
  viewClaimExcApproval: (id) => `/approval-claim-executive/edit/${id}`,
  viewSecondaryCustomer: `/approval-secondary-customer`,
  viewSecondaryCustomerApproval: (id) => `/approval-secondary-customer/edit/${id}`,
  approveClaimManagerList: `/approval-claim-manager`,
  approveClaimManager: `/approval-claim-manager/view`,
  viewClaimManager: `/approval-claim-manager/edit`,

  viewOrderDetails: (id) => `/primary-order-report/view/${id}`,
  PrimaryOrderDetails: `/primary-order-report`,
  ClaimReportView: `/claim-details-report`,

  ClaimApprovalRM: `/regular-approval-claim-reporting-manager`,
  viewRegularClaimApproval: (id) => `/regular-approval-claim-reporting-manager/edit/${id}`,
  ClaimApprovalDM: `/regular-approval-claim-division-manager`,
  viewRegularClaimApprovalDM: (id) => `/regular-approval-claim-division-manager/edit/${id}`,
  ClaimApprovalHR: `/regular-approval-claim-hr`,
  viewRegularClaimApprovalHR: (id) => `/regular-approval-claim-hr/edit/${id}`,
  ClaimApprovalAccExe: `/regular-approval-claim-accounts-executive`,
  viewRegularClaimApprovalAccExe: (id) => `/regular-approval-claim-accounts-executive/edit/${id}`,
  ClaimApprovalAccMan: `/regular-approval-claim-accounts-manager`,
  viewRegularClaimApprovalAccMan: (id) => `/regular-approval-claim-accounts-manager/edit/${id}`,
  viewClaimSmartForm: (id) => `/regular-approval-claim-accounts-manager/view/${id}`,

  PlanDeviationApproveManager: `/plan-deviation-approval-manager`,
  divisionMaster: '/division-master',
  plantMaster: '/plant-master',
  login: '/login',
  attendanceReport: '/attendance-report',
  appTrackReport: '/app-track-report',
  travelReport: '/travel-report',
  prospectMaster: '/prospect-master',
  shiftMaster: '/shift-master',
  dropdown: '/dropdown-master',
  dropdownlist: '/dropdownlist',
  ifdCompetitorMaster: '/ifd-competitor-master',
  venueMaster: '/venue-master',
  menuMaster: '/menu-master',
  areas: '/area-master',
  outletMaster: '/outlet-master',
  PrimaryCustomerMaster: '/customer-master',
  competitorOffers: '/competitor-offers',
  companyMasterCreate: '/company-master/create',
  claimCreate: '/claim-creation/create',
  ifdCompetitorMasterCreate: '/ifd-competitor-master/create',
  fdCompetitorMasterCreate: '/fd-competitor-master/create',
  competitorOffersCreate: '/competitor-offers/create',
  divisionMasterCreate: '/division-master/create',
  primaryCustomerMasterCreate: '/primary-customer-master/create',
  employeeMasterCreate: '/employee-master/create',
  venueMasterCreate: '/venue-master/create',
  userMasterCreate: '/user-master/create',
  employeeMappingCreate: '/employee-mapping/create',
  userMappingCreate: '/user-mapping/create',
  plantMasterCreate: '/plant-master/create',
  menuAccessCreate: '/menu-access/create',
  shiftMasterCreate: '/shift-master/create',
  planCreationCreate: '/pjp-creation/create',
  outletMasterCreate: '/outlet-master/create',
  prospectMasterCreate: '/prospect-master/create',
  planApprovalManager: '/plan-validation-manager',
  viewPlanManager: (id) => `/plan-validation-manager/edit/${id}`,
  bOPlanApproval: '/plan-validation',
  ifoodsPlanDeviation: '/plan-deviation-approval-backoffice',
  PlanApprovalFoods: '/approval-foods',
  claimCreation: '/claim-creation',
  calendarEvent: '/calendar-event',
  calendarEventCreate: '/calendar-event/create',
  dashboardSlider: '/dashboard-slider',
  dashboardSliderCreate: '/dashboard-slider/create',
  editDashboardSlider: (id) => `/dashboard-slider/edit/${id}`,
  ProspectValidation: '/prospect-validation',
  pjpMaster: '/pjp-creation',
  terms: '/terms',
  policy: '/policy',
  deactivate: '/deactivate',

  //===================Sooji QR Bag ===========================//

  newBagRequest: "/new-bag-request",
  newBagRequestCreate:"/new-bag-request/create", 
  bagRequest: "/bag-request",
  bagRequestCreate:"/bag-request/create",
  bagIssue: "/bag-issue",
  bagIssueCreate:"/bag-issue/create", 
  storeNewBagRequest: "/store-new-bag-request",
  storeNewBagRequestCreate:"/store-new-bag-request/create",   
  bagReport: "/bag-report",
  fillBag: "/fill-bag/create",
  qcRelease: "/qc-release",
  qcReleaseExceeded: "/quality-check-exceeded",
  qcReleaseCreate:"/qc-release/create", 
  editQcReleaseCreate: (id) => `/qc-release/edit/${id}`,
  roastingProcess: "/roasting-process",
  roastingProcessExceeded: "/roasting-exceeded",
  roastingProcessCreate:"/roasting-process/create", 
  fumigationProcess: "/fumigation-process",
  fumigationProcessExceeded: "/fumigation-exceeded",
  fumigationProcessCreate:"/fumigation-process/create", 
  qrTransReport: "/qr-trans-report",
  qrTransReportCreate:"/qr-trans-report/create",

  /* Foods Scheme*/
 
  schemeCreation: "/scheme-creation",
  schemeCreationCreate: "/scheme-creation/create",
  editSchemeCreation: (id) => `/scheme-creation/edit/${id}`, 

        schemeCreationApproval: "/scheme-creation-approval",
        schemeCreationApprovalCreate: "/scheme-creation-approval/create",
        editSchemeCreationApproval: (id) => `/scheme-creation-approval/edit/${id}`,
        getSchemeCreationApproved: "/scheme-creation-approved",
        schemeCreationApprovalCH: "/scheme-creation-approval-ch",
        schemeCreationApprovalBH: "/scheme-creation-approval-bh",
        editSchemesListMaster: (id) => `/scheme-status-master/edit/${id}`, /* Scheme Status View */
        schemeStatusListView: "/scheme-status-master", /* Scheme Status View */
        schemeNonEligibleListView: "/scheme-non-eligible-approval", /* Scheme Not Eligible View */
        editSchemesNonEligibleListMaster: (id) => `/scheme-non-eligible-approval/edit/${id}`,
        editSchemesListMasterAll: (id) => `/scheme-status-master-all/edit/${id}`, /* Scheme Status View */

  editSchemeGMapproval: (id) => `/scheme-gm-approval/edit/${id}`, /* Scheme GM Approval View */
  schemeGMapprovalView: "/scheme-gm-approval", /* Scheme GM Approval View */
  editSchemeGMRejected: (id) => `/scheme-gm-rejected/edit/${id}`, /* Scheme GM Rejected View */
  schemeGMRejected: "/scheme-gm-rejected", /* Scheme GM Rejected View */
  editSchemeCHapproval: (id) => `/scheme-ch-approval/edit/${id}`, /* Scheme CH Approval View */
  editSchemeCHRejected: (id) => `/scheme-ch-rejected/edit/${id}`, /* Scheme GM Rejected View */
  schemeCHapprovalView: "/scheme-ch-approval", /* Scheme CH Approval View */
  schemeCHRejected: "/scheme-ch-rejected", /* Scheme GM Rejected View */
  editSchemeBHapproval: (id) => `/scheme-bh-approval/edit/${id}`, /* Scheme BH Approval View */
  schemeBHapprovalView: "/scheme-bh-approval", /* Scheme BH Approval View */
  editSchemeBHRejected: (id) => `/scheme-bh-rejected/edit/${id}`, /* Scheme GM Rejected View */
  schemeBHRejected: "/scheme-bh-rejected", /* Scheme GM Rejected View */
  editSchemeAHCreditNoteApproval: (id) => `/scheme-ah-credit-note-approval/edit/${id}`, 
  schemeAHCreditNoteApprovalView: "/scheme-ah-credit-note-approval", 
          /* Scheme AH credit notw view */
  editSchemeCreditnoteReport: (id) => `/scheme-credit-note-report/edit/${id}`, 
  schemeCreditnoteReportView: "/scheme-ah-credit-note-report", 
  schemeCostCenterActualReport: "/scheme-cost-center-actual-report",
  schemeCustomerWiseReport: "/scheme-customer-wise-report",
  schemeRejectedCustomerReport: "/scheme-rejected-customer-report",
  
  /* Pest Control */
  pestControlDailyEntry: "/pest-control/daily-entry",
  pestControlReport: "/pest-control/report",
  rodentBoxLocationMaster: "/pest-control/rodent-box-location",
  locationTrapStationMapping: "/pest-control/location-trap-station-mapping",
  rodentQRCodeMapping: "/pest-control/rodent-qr-code-mapping",
  rodentQRCode: "/pest-control/rodent-qr-code",

  noAccess: (redirectedFrom) => `/no-access${redirectedFrom ?
     `?redirectedFrom=${redirectedFrom}` : ''}`
};

export default navs;
